import { FuelType } from './energy/energy.enums';
import { ProductCategory } from './product-category.model';

export class ProductSearchRequestModel {
  public floorNumber?: string;
  public unitNumber?: string;
  public streetNumber?: string;
  public streetName?: string;
  public streetType?: string;
  public streetTypeSuffix?: string;
  public suburb?: string;
  public state: string;
  public postcode?: string;
  public customerType?: CustomerType;
  public latitude?: string;
  public longitude?: string;
  public webCampaignId?: string;
  public deliveryPointId?: string;
  public productCategoriesToSearch?: ProductCategory[];
  public nbnProductLoaded?: boolean; // Set to true when nbn products have been loaded and saved in sessionStorage
  public defaultSearch?: boolean;
  public fuelType?: FuelType;
  public couponCode?: string;
  public shouldReturnDiscounts?: boolean;
}

export enum CustomerType {
  business = 'business',
  residential = 'residential'
}
